import React from 'react';
import MainBody from '../templates/MainBody';
import { weapintContent } from '../data';

//legal firearms intelligence gathering techniques and tools, registries, sales ect
//constraints around this intelligence collection

const WEAPINT: React.FC = () => {
  return <MainBody data={weapintContent} />;
};

export default WEAPINT;